import { Switch } from 'formik-mui'
import { first } from 'lodash'
import React, { useCallback } from 'react'
import { SignalLogic } from 'scenes/Dashboard/data/logic'
import { SignalAssessment } from 'scenes/Dashboard/data/signalAssessments/types'
import { insertItem, removeItemByIndex } from 'utils-next/arrays'
import { connect, FastField, FormProps } from 'utils-next/forms'

import { FormControlLabel, Typography } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

import AddItemButton from '../../../../../AddItemButton'
import { OrganizationFormValues } from '../../OrganizationDetailsEdit.models'
import styles from '../FormSection.styles'
import Signal from './Signal.component'

type OuterSignalListProps = { founders: string[] }

type SignalListProps = OuterSignalListProps & WithStyles<typeof styles> & { formik: FormProps<OrganizationFormValues> }

function SignalList({
  classes,
  formik: {
    setFieldValue,
    values: { signalAssessmentsValues },
  },
  founders,
}: SignalListProps) {
  const buildNewSignalAssessment = useCallback(
    (): SignalAssessment => ({
      signalLogic: first(Object.values(SignalLogic)),
      assessmentSupportiveData: { description: '', summary: '' },
    }),
    []
  )

  const onNewItemClick = useCallback(
    () => setFieldValue('signalAssessmentsValues', insertItem(signalAssessmentsValues, buildNewSignalAssessment())),
    [buildNewSignalAssessment, setFieldValue, signalAssessmentsValues]
  )

  const onRemoveItemClick = useCallback(
    (index: number) => {
      return () => {
        setFieldValue('signalAssessmentsValues', removeItemByIndex(signalAssessmentsValues, index))
      }
    },
    [setFieldValue, signalAssessmentsValues]
  )

  return (
    <div className={classes.sectionContainer}>
      <Typography variant="h6">Signals</Typography>

      <FormControlLabel
        control={<FastField type="checkbox" name="balancedFoundingTeamValue" component={Switch} color="secondary" />}
        className={classes.sectionItem}
        label="Balanced founding team"
      />

      <FormControlLabel
        control={
          <FastField
            type="checkbox"
            name="foundersHaveOtherRelevantExperienceValue"
            component={Switch}
            color="secondary"
          />
        }
        className={classes.sectionItem}
        label="Other relevant experience"
      />

      <FormControlLabel
        control={
          <FastField type="checkbox" name="techFounderWithRelevantDegreeValue" component={Switch} color="secondary" />
        }
        className={classes.sectionItem}
        label="Non top tech education"
      />

      {signalAssessmentsValues.map((signal, index) => (
        <Signal
          className={classes.sectionItem}
          index={index}
          key={`${signal.id}-signal-${index}`}
          onRemoveItem={onRemoveItemClick(index)}
          signal={signal}
          founders={founders}
        />
      ))}

      <AddItemButton label="Add Signal" onClick={onNewItemClick}>
        Add Signal
      </AddItemButton>
    </div>
  )
}

export default connect<OuterSignalListProps, OrganizationFormValues>(withStyles(styles)(SignalList))
